<template>
  <div class="layout-tags-content">
    <div class="tag-header">
      <div class="tag-groupname">{{ moduleNameAndLength }}</div>
      <div class="tag-btns">
        <kye-button type="text" @click="handleBatch" v-if="!isBatchFlag">
          <img src="../../images/module.svg" style="transform: translateY(1px)" />
          批量操作
        </kye-button>
        <template v-if="isBatchFlag">
          <kye-button type="text" @click="handleBatchMove">
            <img src="../../images/tag-move.svg" style="transform: translateY(1px)" />
            批量移动
          </kye-button>
          <kye-button type="text" @click="handleBatchDelete">
            <img src="../../images/tag-del.svg" style="transform: translateY(1px)"/>
            批量删除
          </kye-button>
          <kye-button type="text" @click="handleBatchCancel">
            <img src="../../images/tag-cancel.svg" style="transform: translateY(1px)"/>
            取消
          </kye-button>
        </template>
      </div>
      <div class="tag-tip">可选择多个批量移动分组</div>
    </div>
    <div class="tag-body">
      <div class="add-tag-btn" @click="handleAdd">
        <img src="../../images/add-plus.png" />
        <span>添加常用</span>
      </div>
      <kye-checkbox-group v-model="checkList">
        <draggable
          ref="draggable"
          class="layout-tags-box"
          :list="tags"
          @change="onSortChange"
          v-bind="dragOptions">
            <kye-checkbox
              class="tag-box menu-tag"
              v-for="(tag, index) in tags"
              :key="tag.id"
              :label="tag.id"
              :disabled="!isBatchFlag"
              :class="{'first-tag': index === 0, 'active-tag': hasActived(tag.id), 'tag-none': !isBatchFlag}">
              <span class="tag-text">{{tag.title}}</span>
              <template v-if="!isBatchFlag">
                <el-dropdown @command="val => handleCommand(val, tag, 'single')">
                  <div class="more-icon-box">
                    <img src="../../images/more.svg" style="transform:translateY(0px);cursor:pointer" class="more-icon"/>
                    <img src="../../images/more-hover.svg" style="transform:translateY(0px);cursor:pointer" class="more-icon-hover"/>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="move" class="layout-tag-action-row"><img src="../../images/move.svg" alt="">移动到</el-dropdown-item>
                    <el-dropdown-item command="delete" class="layout-tag-action-row"><img src="../../images/delete.svg" alt="">移除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </kye-checkbox>
        </draggable>
      </kye-checkbox-group>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    props: {
      tags: Array,
      activeItem: Object
    },
    components: { draggable },
    data() {
      return {
        dragOptions: {
          draggable: '.menu-tag',
          handle: '.menu-tag',
          animation: 150,
          ghostClass: 'kye-ghost'
        },
        checkList: [],
        isBatchFlag: false
      }
    },
    computed: {
      // 模块名称和数量
      moduleNameAndLength() {
        return this.activeItem && this.activeItem.groupName ? `${this.activeItem.groupName}(${this.tags.length})` : ''
      }
    },
    methods: {
      /**
       * 初始化批量操作数据
       */
      initCheckData() {
        this.checkList = []
      },
      /**
       * 批量操作
       */
      handleBatch () {
        this.isBatchFlag = true
      },
      /**
       * 批量移动
       */
      handleBatchMove() {
        if (!this.checkList.length) {
          this.$message.warning('请先勾选目标模块，然后继续操作')
          return
        }
        const tagVal = this.tags.filter(tag => this.checkList.includes(tag.id))
        this.handleCommand('move', tagVal)
      },
      /**
       * 批量删除
       */
      handleBatchDelete() {
        if (!this.checkList.length) {
          this.$message.warning('请先勾选目标模块，然后继续操作')
          return
        }
        const tagVal = this.tags.filter(tag => this.checkList.includes(tag.id))
        this.handleCommand('delete', tagVal)
      },
      /**
       * 取消批量操作
       */
      handleBatchCancel() {
        this.isBatchFlag = false
        this.checkList = []
      },
      hasActived (id) {
        return this.isBatchFlag && this.checkList.includes(id)
      },
      handleCommand(command, tag, type = 'batch') {
        let value = tag
        if (type === 'single') {
          value = [tag]
        }
        this.$emit(command, value)
      },
      handleAdd () {
        this.$emit('add')
      },
      onSortChange () {
        this.$emit('sortChange')
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-tags-content {
  border: 1px solid #E9E8ED;
  margin-left: 10px;
  position: relative;
  flex: 1;

  .tag-header {
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 12px;
    border-bottom: 1px solid #E9E8ED;
    .tag-groupname {
      margin-right: 8px;
      font-size: 16px;
      font-weight: bolder;
    }
    .tag-btns {
      button {
        margin-left: 0;
      }
      /deep/ {
        .el-button--text + .el-button--text {
          margin-left: 0;
        }
      }
    }
    .tag-tip {
      margin-left: 8px;
      font-size: 12px;
      color: #575561;
    }
  }
  .tag-body {
    height: 350px;
    padding: 12px 0 0 12px;
    overflow-y: auto;
    position: relative;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      cursor: pointer;
      border-radius: 3px;
      background-color: rgba($color: #000000, $alpha: 0.4);
      border: 1px solid white;
    }

    &::-webkit-scrollbar-track {
      border: 0 solid transparent;
      background-color: #fff;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    &::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }
  }
  .add-tag-btn {
    border: 1px solid #DCDCDC;
    color: var(--g-color-primary);
    cursor: pointer;
    height: 28px;
    align-items: center;
    width: fit-content;
    display: flex;
    position: absolute;
    padding: 0 8px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 12px;
    margin: 0 12px 12px 0px;
    img {
      margin-right: 4px;
    }
  }
  .layout-tags-box {
    display: flex;
    flex-wrap: wrap;
    .tag-box {
      height: 28px;
      align-items: center;
      width: fit-content;
      display: flex;
      padding: 0 8px;
      box-sizing: border-box;
      border-radius: 6px;
      font-size: 12px;
      margin: 0 12px 12px 0px;
      border: 1px solid transparent;
      cursor: move;
      &.menu-tag {
        background: #F3F3FD;
        color: #333333;
      }
      &.first-tag {
        margin-left: 94px;
      }
      .tag-text {
        margin-right: 6px;
      }
    }
    .active-tag {
      position: relative;
      border: 1px solid #8b60f0;
    }
    .tag-none {
      cursor: move;
      /deep/ .el-checkbox__input {
        display: none;
      }
      /deep/ .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #333;
        cursor: move;
      }
    }
    .more-icon-box {
      width: 12px;
      height: 12px;
      .more-icon {
        display: block;
      }
      .more-icon-hover {
        display: none;
      }
      &:hover {
        .more-icon {
          display: none;
        }
        .more-icon-hover {
          display: block;
        }
      }
    }
  }
}
.layout-tag-action-row {
  display: flex;
  align-items: center;
  color: #000000 !important;
  &:hover {
    background: #EBECF0;
  }
  img {
    width: 12px;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/tag-list.vue